import React, { Component } from 'react';

import moment from 'moment';

import Button from '@material-ui/core/Button';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import DoneIcon from '@material-ui/icons/Done';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    card: {
        margin: '15px',
        width: '400px',
        maxWidth: '90%',
        textAlign: 'left',
        height: '65%'
    },
    cardActions: {
        width: '100%',
        minHeight: '60px'
    },
    cardHeader: {
        marginBottom: '10px'
    },
    delivBtn: {
        marginTop: '5px',
        float: 'right'
    },
    grid: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: '10px',
        paddingBottom: '100px'
    },
    hcard: {
        width: '800px',
        minHeight: "100px",
        maxWidth: '90%',
        minHeigth: '160px',
        textAlign: 'center',
        color: "black",
        backgroundColor: "rgb(255, 255, 255,0.5)"
    },
    header: {
        color: "black",
        fontSize: '1.5em',
        justifyContent: 'center'
    },
    headerDivider: {
        marginBottom: '15px'
    },
    input100: {
        marginTop: '15px',
        width: '100%'
    },
    orderStatus: {
        color: '#444'
    },
    root: {
        marginTop: '80px',
    },
    subHeader: {
        color: "black",
        fontSize: '1.2em',
        justifyContent: 'center',
        marginTop: '10px'
    },
});

class Orders extends Component {
    constructor(props) {
        super(props);

        this.state = {};
        this.state.orders = this.props.orders;

        this.state.completed = true;
        this.state.mounted = false;

        //*** Dates
        let dates = [];
        this.props.orders.forEach(i => {
            let _date;
            let _dateStr;
            try {
                _date = moment(
                    parseInt(this.props.orders[0]._status_update.seconds.toString() 
                        + "000",10));
                _dateStr = _date.format('YYYY-MM-DDTHH:mm');
            } catch (err) {
                //No _status_update field
            }

            dates.push({
                orderId: i.order_id,
                date: i._status_update ? _dateStr:''
            });
        });
        this.state.dates = dates;

        //*** Notes
        let notes = [];
        this.props.orders.forEach(i => {
            notes.push({
                orderId: i.order_id,
                note: i.note ? i.note : ''
            });
        });
        this.state.notes = notes;

        //*** Editable
        let editable = [];
        this.props.orders.forEach(i => {
            editable[i.order_id] = false;
        });
        this.state.editable = editable;

        //***
        this.btnCancelClick = this.btnCancelClick.bind(this);
        this.btnDelivClick = this.btnDelivClick.bind(this);
        this.btnOkClick = this.btnOkClick.bind(this);
        this.dateChanged = this.dateChanged.bind(this);
        this.noteChanged = this.noteChanged.bind(this);
    }

    componentDidMount() {
        this.setState({ 'mounted': true });

        this.checkDeliveryStatus();
    }

    componentDidUpdate() {
        if (this.state.orders === this.props.orders) {
            return;
        }

        this.setState({ 'orders': this.props.orders });

        this.checkDates();
        this.checkDeliveryStatus(); 
        this.checkNotes();
    }

    //*****
    btnCancelClick(e) {
        let id = e.currentTarget.id;

        let notes = this.state.notes.map(i => i);
        this.state.orders.forEach(i => {
            this.setNote(i.order_id, i.note);
        });
        this.setState({ 'notes': notes });

        let dates = this.state.dates.map(i => i);
        this.state.orders.forEach(i => {
            if (i._status_update){
                let _date = 
                    moment(
                        parseInt(i._status_update.seconds.toString() + "000",10));
                let _dateStr = _date.format('YYYY-MM-DDTHH:mm');

                this.setDate(i.order_id, _dateStr);
            }
        });
        this.setState({ 'dates': dates });

        let editable = { ...this.state.editable };
        editable[id] = false;
        this.setState({ 'editable': editable });
    }

    btnDelivClick(e) {
        const btn = e.currentTarget;
        const orderid = btn.getAttribute('data-order');
        const status = parseInt(btn.getAttribute('data-status'), 10);

        const data = {
            action: 0,
            note: this.getNote(orderid),
            date: moment().format('YYYY-MM-DDTHH:mm:ss'),
            order: orderid,
            status: status
        }

        this.props.onClick(data);
    }

    btnOkClick(e) {
        const btn = e.currentTarget;
        const orderid = e.currentTarget.id;
        const status = parseInt(btn.getAttribute('data-status'), 10);

        let orders = this.state.orders.map(i => {
            if (i.order_id === orderid) {
                i.note = this.getNote(i.order_id);
                i.date = this.getDate(i.order_id);
            }
            return i;
        });
        this.setState({ 'orders': orders });

        let editable = { ...this.state.editable };
        editable[orderid] = false;
        this.setState({ 'editable': editable });

        const data = {
            action: 1,
            note: this.getNote(orderid),
            date: this.getDate(orderid),
            order: orderid,
            status: status,
        }
        
        this.props.onClick(data);
    }

    checkDeliveryStatus() {
        let delivCompleted = true;

        this.props.orders.forEach(i => {
            if (i._status === 0) { delivCompleted = false; }
        });

        if (this.state.completed !== delivCompleted) {
            this.setState({ 'completed': delivCompleted });

            if (delivCompleted) {
                this.setState({ 'editable': false });
            } else {
                this.setState({ 'editable': true });
            }
        }
    }

    checkDates() {
        this.props.orders.forEach(i => {
            if (i._status_update){
                let _date = 
                    moment(
                        parseInt(i._status_update.seconds.toString() + "000",10));
                    let _dateStr = _date.format('YYYY-MM-DDTHH:mm');

                let date = this.getDate(i.order_id);

                if (_dateStr !== date) {
                    this.setDate(i.order_id, _dateStr);
                }
            }
        });
    }

    checkNotes() {
        this.props.orders.forEach(i => {
            let note = this.getNote(i.order_id);
            if (i.note !== note) {
                this.setNote(i.order_id, i.note);
            }
        });
    }

    dateChanged(e) {
        let id = e.target.id.split('date_')[1];

        this.setDate(id, e.currentTarget.value);

        let editable = { ...this.state.editable };
        editable[id] = true;
        this.setState({ 'editable': editable });
    }

    getDate(orderId) {
        let date = '';
        this.state.dates.forEach(i => {
            if (i.orderId === orderId) {
                date = i.date || '';
            }
        });

        return date;
    }

    getNote(orderId) {
        let note = '';
        this.state.notes.forEach(i => {
            if (i.orderId === orderId) {
                note = i.note || '';
            }
        });

        return note;
    }

    noteChanged(e) {
        let id = e.target.id.split('note_')[1];

        this.setNote(id, e.currentTarget.value);

        let editable = { ...this.state.editable };
        editable[id] = true;
        this.setState({ 'editable': editable });
    }

    setDate(orderId, date) {
        let dateChanged = false;
        let _dates = this.state.dates.map(i => i);

        _dates.forEach(i => {
            if (i.orderId === orderId) {
                if (i.date !== date) {
                    i.date = date;
                    dateChanged = true;
                }
            }
        });

        if (dateChanged) {
            this.setState({ dates: _dates });
        }
    }

    setNote(orderId, note) {
        let noteChanged = false;
        let _notes = this.state.notes.map(i => i);

        _notes.forEach(i => {
            if (i.orderId === orderId) {
                if (i.note !== note) {
                    i.note = note;
                    noteChanged = true;
                }
            }
        });

        if (noteChanged) {
            this.setState({ notes: _notes });
        }
    }

    //***
    render() {
        const { classes, texts } = this.props;

        if (this.props.orders.length === 0) {
            return null;
        }

        let orders = this.state.orders.map(i => {
            if (i._status === undefined) {
                i._status = 0;
            }
            return i;
        });

        return (
            <div className={classes.root}>
                <div className={classes.header}>
                    {texts.delivery} {this.props.delivery.delivery}
                </div>
                <div className={classes.subHeader}>
                    {texts.orders}
                </div>
                <div className={classes.grid}>
                    {orders.map(order => (
                        <Card id={order.order_id} key={order.order_id} 
                            className={classes.card}>
                            <CardContent>
                                <Typography className={classes.cardHeader} variant="h5"
                                    component="h2">
                                    {order.order_doc}
                                </Typography>
                                <Divider className={classes.headerDivider} />
                                <Typography className={classes.orderStatus}>
                                    <b>{texts.status}:&nbsp;
                                    {order._status === 0 && texts.progress}
                                        {order._status === 1 && texts.ddone}</b><br /><br />
                                </Typography>
                                {texts.customer}: {order.customer_name}<br />
                                {texts.boar}: {order.customer_branch_name}<br />
                                {texts.address}: {order.order_address}<br />

                                {(order._status === 1 &&
                                    <TextField id={'date_' + order.order_id}
                                        className={classes.input100}
                                        disabled={this.state.completed}
                                        label={texts.delivery}
                                        placeholder=' '
                                        type="datetime-local"
                                        value={this.getDate(order.order_id)}
                                        onChange={this.dateChanged} />) ||
                                 (order._status === 0 &&
                                    <TextField id={'date_' + order.order_id}
                                        className={classes.input100}
                                        disabled={true}
                                        label={texts.delivery}
                                        placeholder=' '
                                        value=''/>)}

                                <TextField id={'note_' + order.order_id}
                                    className={classes.input100}
                                    disabled={this.state.completed}
                                    label={texts.note}
                                    value={this.getNote(order.order_id)}
                                    onChange={this.noteChanged} />
                            </CardContent>
                            <Divider />
                            <CardActions className={classes.cardActions}>
                                {this.state.editable[order.order_id] &&
                                    <Grid container>
                                        <Grid item xs={2}>
                                            <IconButton
                                                id={order.order_id}
                                                color="primary"
                                                data-status={order._status}
                                                onClick={this.btnOkClick}>
                                                <DoneIcon />
                                            </IconButton>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <IconButton
                                                id={order.order_id}
                                                color="primary"
                                                onClick={this.btnCancelClick}>
                                                <CancelIcon />
                                            </IconButton>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Button className={classes.delivBtn}
                                                color="primary"
                                                id="btn"
                                                data-order={order.order_id}
                                                data-status={order._status}
                                                data-note={order.note}
                                                onClick={this.btnDelivClick}>

                                                {order._status === 0 && texts.deliv}
                                                {order._status === 1 && texts.cdeliv}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }
                                {(!this.state.editable[order.order_id]) &&
                                    !this.state.completed &&
                                    <Grid container>
                                        <Grid item xs={4}></Grid>
                                        <Grid item xs={8}>
                                            <Button className={classes.delivBtn}
                                                color="primary"
                                                id="btn"
                                                data-order={order.order_id}
                                                data-status={order._status}
                                                data-note={order.note}
                                                onClick={this.btnDelivClick}>

                                                {order._status === 0 && texts.deliv}
                                                {order._status === 1 && texts.cdeliv}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }
                            </CardActions>
                        </Card>
                    ))}
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(Orders);


// WEBPACK FOOTER //
// ./src/components/Orders/index.js